import { Component, OnInit, Input } from '@angular/core';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "base-accordion",
  templateUrl: "./base-accordion.component.html",
  styleUrls: ["./base-accordion.component.scss"]
})
export class BaseAccordionComponent implements OnInit {
  @Input() seleniumName: string;
  @Input() isOpen: boolean;
  @Input() svgIcon = 'icon_chevron.svg';
  @Input() themeSVGStroke: boolean;

  constructor() {
    this.isOpen = true;
  }

  ngOnInit() {}

  toggle() {
    this.isOpen = !this.isOpen;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/base-accordion/base-accordion.component.ts